var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackHomeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.220312 5.46602C-0.0734375 5.75977 -0.0734375 6.23477 0.220312 6.52539L5.47031 11.7785C5.76406 12.0723 6.23906 12.0723 6.52969 11.7785C6.82031 11.4848 6.82344 11.0098 6.52969 10.7191L2.56094 6.74727H12.1891C12.6047 6.74727 12.9391 6.41289 12.9391 5.99727C12.9391 5.58164 12.6047 5.24727 12.1891 5.24727H2.56094L6.53281 1.27852C6.82656 0.984767 6.82656 0.509767 6.53281 0.219142C6.23906 -0.0714828 5.76406 -0.0746078 5.47344 0.219142L0.220312 5.46602Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackHomeArrow);
export default __webpack_public_path__ + "static/media/back-home-arrow.22a1bca13d0f024424811d24b3d7f347.svg";
export { ForwardRef as ReactComponent };